/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookienoticeheading2Inputs */



/**
* | output |
* | --- |
* | "We use cookies" |
*
* @param {Cookienoticeheading2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cookienoticeheading2 = /** @type {((inputs?: Cookienoticeheading2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookienoticeheading2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("We use cookies")
	return /** @type {LocalizedString} */ ("Wir verwenden Cookies")
});
export { cookienoticeheading2 as "cookieNoticeHeading" }